 

import { UPDATE_UI, SET_DM_SIDEBAR_OPEN } from './ui-actions';

const initialState = {
  dmSidebarOpen: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_UI:
      return {
        ...state,
        [action.payload.id]: action.payload.uiRect,
      };
    case SET_DM_SIDEBAR_OPEN:
      return {
        ...state,
        dmSidebarOpen: action.payload.isOpen,
      };
    default:
      return state;
  }
};
